




import { JournalEntry } from "../../models/JournalEntry";
import EStatus = JournalEntry.EStatus;

export default {
    name: "JournalCommentStatusIndicator",
    props: {
        entry: JournalEntry,
    },
    computed: {
        statusClass(): string {
            if (this.entry.status === EStatus.Closed) {
                return "closed";
            } else if (this.entry.isLate) {
                return "late";
            } else {
                return "pending";
            }
        },
    },
};
